// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"2089fce722","253":"a6583ec29f","619":"f67e729307"}[chunkId] + ".js";
};